export { getChildren } from '@fluentui/dom-utilities';
//# sourceMappingURL=getChildren.js.map